import { API_BASE_URL, DEFAULT_COMPANY_ID } from './config';

export type RefreshResponse = {
  success: boolean;
  data?: {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
  };
  error?: string;
};

export type LoginResponse = {
  success: boolean;
  data?: {
    user: {
      id: string;
      email: string;
      name: string;
      role: string;
      companyId: string;
      divisionId?: string;
      isActive: boolean;
    };
    tokens: {
      accessToken: string;
      refreshToken: string;
      expiresIn: number;
    };
  };
  error?: string;
};

export async function login(email: string, password: string, companyId?: string): Promise<LoginResponse> {
  // companyId = '' or undefined → super_admin login (no company)
  // companyId not provided → use default company
  const resolvedCompanyId = companyId !== undefined ? companyId : DEFAULT_COMPANY_ID;
  const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password, companyId: resolvedCompanyId || undefined }),
  });

  return response.json();
}

export async function getMe(accessToken: string): Promise<LoginResponse> {
  const response = await fetch(`${API_BASE_URL}/api/auth/me`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return response.json();
}

/** Call POST /api/auth/refresh to get a new access token using the stored refresh token. */
export async function refreshToken(currentRefreshToken: string): Promise<RefreshResponse> {
  const response = await fetch(`${API_BASE_URL}/api/auth/refresh`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refreshToken: currentRefreshToken }),
  });
  return response.json();
}
